// A colour param as two mappable numbers: its HSV hue and brightness, each written back into the hex with the other channels kept.

export const CHANNELS = {
	hue: Object.freeze({ type: 'number', minimum: 0, maximum: 360, step: 1, label: 'Hue' }),
	brightness: Object.freeze({ type: 'number', minimum: 0, maximum: 1, step: 0.001, label: 'Brightness' }),
}

/** Is `schema` a colour a channel target can drive? */
export const isColorSchema = schema => schema?.kind === 'color' || schema?.flags?.kind === 'color'

const HEX = /^#([0-9a-f]{6})([0-9a-f]{2})?$/i

const toHsv = hex => {
	const m = HEX.exec(hex ?? '')
	if (!m) return null
	const n = parseInt(m[1], 16)
	const [r, g, b] = [n >> 16, (n >> 8) & 255, n & 255].map(c => c / 255)
	const max = Math.max(r, g, b)
	const d = max - Math.min(r, g, b)
	const h = !d ? 0 : max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4
	return { h: (h * 60 + 360) % 360, s: max ? d / max : 0, v: max, alpha: m[2] ?? '' }
}

const toHex = ({ h, s, v, alpha }) => {
	const f = n => {
		const k = (n + h / 60) % 6
		return Math.round(255 * (v - v * s * Math.max(0, Math.min(k, 4 - k, 1))))
	}
	return `#${[f(5), f(3), f(1)].map(c => c.toString(16).padStart(2, '0')).join('')}${alpha}`
}

/** `hex`'s value on `channel`; undefined for anything but a hex colour. */
export const readChannel = (hex, channel) => {
	const c = toHsv(hex)
	return c ? (channel === 'hue' ? c.h : c.v) : undefined
}

/** `hex` with `channel` set to `value`, its other channels (and alpha) kept; `hex` itself when it is not one. */
export const writeChannel = (hex, channel, value) => {
	const c = toHsv(hex)
	if (!c) return hex
	return toHex(
		channel === 'hue' ? { ...c, h: ((value % 360) + 360) % 360 } : { ...c, v: Math.min(1, Math.max(0, value)) }
	)
}
